export interface IMemberDesignersLicenseItem {

    ID: number;
    Key: string;
    LicenseStatus: string;
    Product_ID: number;
    Product: string;
    SoftwareVersion: string;
    CompatibilityToken: string;
    SoftwareVersionInt: number;
    PastDue: boolean;
    TOS: boolean;
    Registered: boolean;

}

export class MemberDesignersLicenseItem implements IMemberDesignersLicenseItem {

    ID: number;
    Key: string;
    LicenseStatus: string;
    Product_ID: number;
    Product: string;
    SoftwareVersion: string;
    CompatibilityToken: string;
    SoftwareVersionInt: number;
    PastDue: boolean;
    TOS: boolean;
    Registered: boolean;

}


export class MemberDesignersLicenseItemArray extends Array<MemberDesignersLicenseItem> {

    constructor(...items: MemberDesignersLicenseItem[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberDesignersLicenseItemArray.prototype);
    }

}